import SectionHeading from "./SectionHeading";
import { StaggerGroup, StaggerItem, Reveal } from "../shared/Reveal";
import { SUPPORT } from "../../data/homeContent";

export default function Support() {
  return (
    <section className="bg-background py-20 md:py-28 lg:py-36" data-testid="support-section">
      <div className="container-psv">
        <SectionHeading eyebrow={SUPPORT.eyebrow} heading={SUPPORT.heading} />
        <StaggerGroup className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-4">
          {SUPPORT.cards.map((c, i) => (
            <StaggerItem key={c} className="flex items-center gap-4 py-4 border-b border-border">
              <span className="font-sans text-sm text-accent tabular-nums w-8">{String(i + 1).padStart(2, "0")}</span>
              <span className="text-lg text-primary font-sans">{c}</span>
            </StaggerItem>
          ))}
        </StaggerGroup>
        <Reveal delay={0.1} className="mt-10 max-w-3xl">
          <p className="text-sm text-muted-foreground leading-relaxed">{SUPPORT.note}</p>
        </Reveal>
      </div>
    </section>
  );
}
